export default __webpack_public_path__ + "static/media/default.0dc9c1dc.png";